export default class Queue {
  constructor() {
    this.queue = {};
  }

  add(id, value) {
    if (!id || !value) {
      return;
    }

    this.queue[id] = value;
  }

  has(id) {
    return this.queue && this.queue[id] && this.queue[id] !== null;
  }

  get(id) {
    if (!id) {
      return;
    }

    return this.queue[id];
  }

  remove(id) {
    if (!id) {
      return;
    }

    delete this.queue[id];
  }

  list() {
    return this.queue;
  }
}
